import React, { useEffect, useState } from "react";
import { Card, Switch, Button, Form, message, Row, Col, Spin } from "antd";
import RequestHandler from "../../util/RequestHandler";
import { KeyOutlined } from "@ant-design/icons";
const formItemLayout = {
  labelCol: {
    xs: {
      span: 12,
    },
    sm: {
      span: 12,
    },
  },
  wrapperCol: {
    xs: {
      span: 12,
    },
    sm: {
      span: 12,
    },
  },
};
const TenantScreenSettings = () => {
  const [updateForm, setUpdateForm] = useState({ data: [], loading: false });
  const [loading, setLoading] = useState(false);
  const [
    phoneFieldUsingAlreadyScreenList,
    setPhoneFieldUsingAlreadyScreenList,
  ] = useState([3, 6]);
  const [
    notUseCurrencyDropdownScreenList,
    setNotUseCurrencyDropdownScreenList,
  ] = useState([2, 5]);

  const [
    b2BShowInstallmentOptionsOnBinCheckList,
    setB2BShowInstallmentOptionsOnBinCheckList,
  ] = useState([1, 3, 4]);

  const [
    b2BShowCommissionIncludedOptionList,
    setB2BShowCommissionIncludedOptionList,
  ] = useState([1]);

  useEffect(() => {
    getUpdateFormData();
  }, []);

  const getUpdateFormData = () => {
    setUpdateForm((prev) => ({ ...prev, loading: true }));
    RequestHandler.get("/TenantScreenSetting").then((response) => {
      if (!response) {
        return setUpdateForm((prev) => ({ ...prev, loading: false }));
      }

      setUpdateForm({ data: response.value || [], loading: false });
    });
  };

  const handleSwitchChange = (id, field, value) => {
    setUpdateForm((prevState) => ({
      ...prevState,
      data: prevState.data.map((item) =>
        item.id === id ? { ...item, [field]: value } : item
      ),
    }));
  };

  const handleUpdate = () => {
    try {
      const { data } = updateForm;
      RequestHandler.post(
        "/TenantScreenSetting/UpdateTenantScreenSettings",
        data
      ).then((response) => {
        setLoading(false);
        if (response.success) {
          getUpdateFormData();
        }
      });
    } catch (error) {
      message.error("Güncelleme sırasında bir hata oluştu.");
    }
  };

  const chunkArray = (arr, size) => {
    const chunks = [];
    for (let i = 0; i < arr.length; i += size) {
      chunks.push(arr.slice(i, i + size));
    }
    return chunks;
  };

  return (
    <Spin spinning={updateForm.loading}>
      <div>
        <Row>
          <Col xs={16}>
            <p style={{ fontSize: "120%", marginTop: -5 }}>
              <KeyOutlined /> EKRAN AYARLARI
            </p>
          </Col>
          <Col xs={8}></Col>
        </Row>

        <Form>
          {chunkArray(updateForm.data, 3).map((group, groupIndex) => (
            <Row justify="center" key={groupIndex}>
              {group.map((item) => (
                <Col xs={24} sm={12} md={8} key={item.id}>
                  <Card
                    title={
                      <span
                        style={{
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        {item.screenName}
                      </span>
                    }
                  >
                    <Form.Item label="Kampanya Butonunu Göster">
                      <Switch
                        checked={item.b2bShowCampaignButton}
                        onChange={(checked) =>
                          handleSwitchChange(
                            item.id,
                            "b2bShowCampaignButton",
                            checked
                          )
                        }
                      />
                    </Form.Item>

                    {item.screenId === 1 && (
                      <Form.Item label="Cari Seçimi Zorunluluğu">
                        <Switch
                          checked={item.b2bFirmSelectRequired}
                          onChange={(checked) =>
                            handleSwitchChange(
                              item.id,
                              "b2bFirmSelectRequired",
                              checked
                            )
                          }
                        />
                      </Form.Item>
                    )}

                    {!notUseCurrencyDropdownScreenList.includes(
                      item.screenId
                    ) && (
                      <Form.Item label="USD'yi Para Birimi Seçiminde Göster">
                        <Switch
                          checked={item.b2bViewUsdOnCurrencyDropDown}
                          onChange={(checked) =>
                            handleSwitchChange(
                              item.id,
                              "b2bViewUsdOnCurrencyDropDown",
                              checked
                            )
                          }
                        />
                      </Form.Item>
                    )}

                    {!notUseCurrencyDropdownScreenList.includes(
                      item.screenId
                    ) && (
                      <Form.Item label="EUR'u Para Birimi Seçiminde Göster">
                        <Switch
                          checked={item.b2bViewEuroOnCurrencyDropDown}
                          onChange={(checked) =>
                            handleSwitchChange(
                              item.id,
                              "b2bViewEuroOnCurrencyDropDown",
                              checked
                            )
                          }
                        />
                      </Form.Item>
                    )}

                    <Form.Item label="Müşteri Bilgisi Alanını Göster">
                      <Switch
                        checked={item.b2bCustomerInformationVisibility}
                        onChange={(checked) =>
                          handleSwitchChange(
                            item.id,
                            "b2bCustomerInformationVisibility",
                            checked
                          )
                        }
                      />
                    </Form.Item>
                    {!phoneFieldUsingAlreadyScreenList.includes(
                      item.screenId
                    ) && (
                      <Form.Item label="Telefon Numarası Alanını Göster">
                        <Switch
                          checked={item.b2bMobilePhoneVisibility}
                          onChange={(checked) =>
                            handleSwitchChange(
                              item.id,
                              "b2bMobilePhoneVisibility",
                              checked
                            )
                          }
                        />
                      </Form.Item>
                    )}

                    <Form.Item label="TC Kimlik Numarası Alanını Göster">
                      <Switch
                        checked={item.b2bTcknVisibility}
                        onChange={(checked) =>
                          handleSwitchChange(
                            item.id,
                            "b2bTcknVisibility",
                            checked
                          )
                        }
                      />
                    </Form.Item>

                    {b2BShowInstallmentOptionsOnBinCheckList.includes(
                      item.screenId
                    ) && (
                      <Form.Item label="Bin Sorgulama Kullanılırken Taksit Seçeneklerini Göster">
                        <Switch
                          checked={item.b2bShowInstallmentOptionsOnBinCheck}
                          onChange={(checked) =>
                            handleSwitchChange(
                              item.id,
                              "b2bShowInstallmentOptionsOnBinCheck",
                              checked
                            )
                          }
                        />
                      </Form.Item>
                    )}

                    <Form.Item label="Komisyon Oranı Bilgisini Gizle">
                      <Switch
                        checked={item.b2bHideCommissionRateInfo}
                        onChange={(checked) =>
                          handleSwitchChange(
                            item.id,
                            "b2bHideCommissionRateInfo",
                            checked
                          )
                        }
                      />
                    </Form.Item>

                    {b2BShowCommissionIncludedOptionList.includes(
                      item.screenId
                    ) && (
                      <Form.Item label="Komisyon Tutara Dahil (KTD) Seçeneğini Göster">
                        <Switch
                          checked={item.b2bShowCommissionIncludedOption}
                          onChange={(checked) =>
                            handleSwitchChange(
                              item.id,
                              "b2bShowCommissionIncludedOption",
                              checked
                            )
                          }
                        />
                      </Form.Item>
                    )}
                  </Card>
                </Col>
              ))}
            </Row>
          ))}

          <Row>
            <Col span={24}>
              <Col style={{ textAlign: "right" }}>
                <Button
                  type="primary"
                  onClick={handleUpdate}
                  disabled={updateForm.loading}
                  loading={loading}
                >
                  Kaydet
                </Button>
              </Col>
            </Col>
          </Row>
        </Form>
      </div>
    </Spin>
  );
};

export default TenantScreenSettings;
